define(["luxon"], function (luxon) {
	"use strict";

	const { DateTime, Settings } = luxon;

	// Formats a JS date object for human readable display, converting to site's timezone if supplied
	// Returns a string representing the date or empty string. Default format is "Sep 23 11:50 am"
	function formatDateTimeInSiteTZ(date, siteTimeZoneId, displayFormat) {
		if (!date) {
			return "";
		}
		let luxonDate = convertJSDateToLuxonDateInSiteTZ(date, siteTimeZoneId);
		return luxonDate.toFormat(displayFormat || "MMM d yyyy h:mm a");
	}

	// Converts a native JS date object (browser TZ dependent) to a luxon date object which can be converted to the site's TZ
	// Accepts: native javascript date object, site's timezone ID (ex. "America/Toronto")
	// Returns: a moment date object or null
	function convertJSDateToLuxonDateInSiteTZ(jsDate, siteTimeZoneId) {
		if (!jsDate) {
			return null;
		}
		let luxonDate = DateTime.fromJSDate(jsDate, { zone: "utc" });
		if (siteTimeZoneId) {
			luxonDate = luxonDate.setZone(siteTimeZoneId);
		}
		return luxonDate;
	}

	// Get's the device's local time zone string (ex: America/Chicago)
	// This is a wrapper for (Intl.DateTimeFormat().resolvedOptions().timeZone), which will work for 99%+ of devices, otherwise luxon will make a guess at the time zone
	function getLocalTimeZone() {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || Settings.defaultZoneName;
	}

	// Gets the length of time between start and end (JS Date) in unitOfTime units (as number). This method will return fractional results
	// which may cause unexpected behavior around DST transitions. The caller should handle this if necessary.
	function getTimeBetween(start, end, unitOfTime) {
		if (!start || !end || !unitOfTime) {
			return null;
		}
		let startDate = DateTime.fromJSDate(start);
		let endDate = DateTime.fromJSDate(end);
		return endDate.diff(startDate, unitOfTime).as(unitOfTime);
	}

	// Checks if the point in time (represented by given JavaScript Date object) is older than given number of hours
	function isOlderThanXHours(date, hours) {
		return DateTime.now().diff(DateTime.fromJSDate(date), "hours").as("hours") >= hours;
	}

	// Returns a formatted string representing today's day with time set to 11:59 pm
	function getTodayMidnight() {
		const today = DateTime.now().set({ hour: 23, minute: 59, second: 0, millisecond: 0 }).setZone("America/Toronto");
		return `${today.toFormat("MMMM d, yyyy h:mm a")} EST`;
	}

	return {
		formatDateTimeInSiteTZ,
		getTimeBetween,
		isOlderThanXHours,
		getTodayMidnight,
		getLocalTimeZone,
	};
});